// This is a WIP component to show when a user tries to access a project they don't have permissions for.
// Design and content to be decided.
import { Alert, Button, Stack, Typography } from '@mui/material';
import { Link, useParams } from 'react-router';

import { useGetProjectById } from '@/api/typesense/projects/useGetProjectById';
import { Icon } from '@/components/ui/Icon';
import { routes } from '@/constants/routes';
import { uiIcons } from '@/constants/uiIcons';

export const ProjectAccessDenied = () => {
  const { projectId } = useParams<{ projectId: string }>();
  const { data: project } = useGetProjectById(projectId!);

  return (
    <Stack
      gap={3}
      alignItems="center"
      justifyContent="center"
      minHeight="400px"
    >
      <Icon name={uiIcons.state.locked} size="xxLarge" color="error" />

      <Stack gap={1} alignItems="center" maxWidth="500px">
        <Typography variant="h1" fontWeight="bold">
          Access Denied
        </Typography>
        <Typography variant="body1" color="text.secondary" textAlign="center">
          You do not have permission to access any sections of this project.
        </Typography>
      </Stack>

      {project && (
        <Alert severity="info" sx={{ maxWidth: '500px' }}>
          <Typography variant="body1">
            <strong>{project.Name}</strong> requires specific permissions to
            view or edit. Please contact your administrator if you believe you
            should have access.
          </Typography>
        </Alert>
      )}

      <Stack direction="row" gap={2}>
        <Button
          component={Link}
          to={routes.projects.base()}
          variant="contained"
          startIcon={<Icon name={uiIcons.navigation.home} />}
        >
          View All Projects
        </Button>
      </Stack>
    </Stack>
  );
};
